import type { Role, ScopeType } from '@vizit/api';

export enum SwitcherEntityKind {
  Organization = 'organization',
  Portfolio = 'portfolio',
  Workspace = 'workspace',
}

export enum SwitcherVariant {
  Org = 'org',
  Portfolio = 'portfolio',
  Workspace = 'workspace',
}

export const ROLE = {
  SuperAdmin: 'super_admin',
  OrgAdmin: 'org_admin',
  PortfolioAdmin: 'portfolio_admin',
  WorkspaceUser: 'workspace_user',
} as const satisfies Record<string, Role>;

export const SCOPE_TYPE = {
  Global: 'global',
  Organization: 'organization',
  Portfolio: 'portfolio',
  Workspace: 'workspace',
} as const satisfies Record<string, ScopeType>;

export const SWITCHER_SECTION_KEY = {
  Organization: 'organization',
  Portfolios: 'portfolios',
  Workspaces: 'workspaces',
} as const;

export const WORKSPACE_PATH_PREFIX = '/w';

export const ACCESS_ROUTES = {
  portfolioGrid: '/portfolios',
  flatWorkspaceGrid: '/workspaces',
  noAccess: '/no-access',
  portfolioWorkspaces: (portfolioId: string) => `/portfolios/${portfolioId}/workspaces`,
  workspaceShell: (workspaceSlug: string) => `${WORKSPACE_PATH_PREFIX}/${workspaceSlug}`,
} as const;
